import { useState } from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../utils/constants";
import useOnlineStatus from "../utils/useOnlineStatus";
import { useSelector } from "react-redux";

const TempHeader = () => {
    const [btnName, setBtnName] = useState("Login");
    const onlineStatus = useOnlineStatus();
    const cartItems = useSelector((store) => store.cart.items);
    const sumOfCartItems = cartItems
        .map((cartItem) => cartItem.quantity)
        .reduce((acc, curr) => acc + curr, 0);

    return (
        <div>
            <nav className="bg-white border-gray-200 px-4 lg:px-6 z-50 border border-double shadow-custom fixed top-0 left-0 w-full">
                <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl">
                    <div>
                        <img
                            className="w-[5.5rem]"
                            src={LOGO_URL}
                            alt="logo-image"
                        />
                    </div>
                    <div className="flex items-center lg:order-2">
                        <button
                            className="hover:bg-gray-50 focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800"
                            onClick={() => {
                                btnName === "Login"
                                    ? setBtnName("Logout")
                                    : setBtnName("Login");
                            }}>
                            {btnName}
                        </button>
                        <button
                            data-collapse-toggle="mobile-menu-2"
                            type="button"
                            className="inline-flex items-center p-2 ml-1 text-sm rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                            aria-controls="mobile-menu-2"
                            aria-expanded="false">
                            <span className="sr-only">Open main menu</span>
                            <svg
                                className="w-6 h-6"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fillRule="evenodd"
                                    d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            <svg
                                className="hidden w-6 h-6"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fillRule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </button>
                    </div>
                    <div
                        className="hidden justify-between items-center w-full lg:flex lg:w-auto lg:order-1"
                        id="mobile-menu-2">
                        <ul className="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0">
                            {onlineStatus === false && (
                                <li className="block py-2 pr-4 pl-3 border-b hover:text-orange-400 border-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-orange-400 lg:p-0 lg:dark:hover:bg-transparent dark:border-gray-700">
                                    Online Status 🔴
                                </li>
                            )}
                            <li className="block py-2 pr-4 pl-3 border-b hover:text-orange-400  border-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-orange-400 lg:p-0 lg:dark:hover:bg-transparent dark:border-gray-700">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="block py-2 pr-4 pl-3 border-b hover:text-orange-400  border-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-orange-400 lg:p-0 lg:dark:hover:bg-transparent dark:border-gray-700">
                                <Link to="/about">About Us</Link>
                            </li>
                            <li className="block py-2 pr-4 pl-3 border-b border-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-orange-400 lg:p-0 lg:dark:hover:bg-transparent dark:border-gray-700">
                                <Link to="/contact">Contact Us</Link>
                            </li>
                            <li className="block py-2 pr-4 pl-3 border-b border-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-orange-400 lg:p-0 lg:dark:hover:bg-transparent dark:border-gray-700">
                                <Link to="/cart">Cart ({sumOfCartItems})</Link>
                            </li>
                            <li className="block py-2 pr-4 pl-3 border-b border-gray-100 lg:hover:bg-transparent lg:border-0 lg:hover:text-orange-400 lg:p-0 lg:dark:hover:bg-transparent dark:border-gray-700">
                                <Link to="/grocery">Grocery</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default TempHeader;
